export class HokReportDto {
  Floor: string;
  AssignedTo: number;
  Supervisor: number;
}
